import { Switch } from '@material-ui/core';
import { withThemeNext } from '../../../../layout/theme-next';

export default withThemeNext(Switch);
